import * as countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import frLocale from "i18n-iso-countries/langs/fr.json";

countries.registerLocale(enLocale);
countries.registerLocale(frLocale);

type SupportedLang = "fr" | "en";

export interface CountryOption {
  value: string; // ISO 3166-1 alpha-2 code
  label: string; // localized country name
}

function normalizeLang(lang?: string): SupportedLang {
  return lang?.slice(0, 2).toLowerCase() === "en" ? "en" : "fr";
}

/**
 * Country Select options for the given UI language. The stored value is the
 * ISO 3166-1 alpha-2 code; the label is the localized country name.
 */
export function getCountryOptions(lang?: string): CountryOption[] {
  const normalized = normalizeLang(lang);
  return Object.entries(countries.getNames(normalized, { select: "official" }))
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, normalized));
}

/**
 * Resolve an ISO alpha-2 code to a localized country name.
 * Falls back to the raw value when it cannot be resolved.
 */
export function getCountryName(code?: string, lang?: string): string {
  if (!code) {
    return "";
  }
  return countries.getName(code, normalizeLang(lang)) ?? code;
}
